import React from 'react'
import { SearchPanelSortOption } from '@Components/Search/SearchPanel/types'

interface SortByProps {
    sortValue?: string
    onSortChange?: (value: string) => void
    sortOptions?: SearchPanelSortOption[]
}

const SortBy = ({ sortValue, onSortChange, sortOptions }: SortByProps) => (
    <div className="sort-by-field">
        <label htmlFor="search-panel-sort">Sort by:</label>
        <select id="search-panel-sort" value={sortValue ?? ''} onChange={(event) => onSortChange?.(event.target.value)}>
            {sortOptions?.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </div>
)

export default SortBy
